<!--
  SupportUploadProgress.svelte — a thin bar showing how much of an upload has
  been sent, under the attachment picker of the new-ticket form and the reply
  composer.

  Rendered only while a send with files is in flight (`progress` is a fraction,
  `null` otherwise): a send without files is quick enough that the button's
  spinner says all there is to say. The percentage is printed beside the bar,
  since a bar alone is hard to read at a glance on a slow connection.
-->
<script lang="ts">
	import { uploadPercent } from '../support/supportFormat';
	import { t } from '../i18n';

	interface Props {
		/** Fraction sent so far, 0–1, or `null` when nothing is uploading. */
		progress: number | null;
	}

	let { progress }: Props = $props();

	/** The fraction as a whole percentage. */
	let percent = $derived(progress === null ? 0 : uploadPercent(progress));
</script>

{#if progress !== null}
	<div class="mt-2 flex items-center gap-3" data-testid="upload-progress">
		<div
			class="h-1.5 grow overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700"
			role="progressbar"
			aria-label={$t('Upload progress')}
			aria-valuemin={0}
			aria-valuemax={100}
			aria-valuenow={percent}
		>
			<div class="bg-primary-500 h-full rounded-full transition-[width] duration-200" style="width: {percent}%"></div>
		</div>
		<span class="text-default shrink-0 text-xs tabular-nums">{$t('Uploading… {{percent}}%', { percent })}</span>
	</div>
{/if}
